export default __webpack_public_path__ + "static/media/background_video.04f63de0.mp4";